'use client'

import { createContext, Dispatch, ReactNode, SetStateAction, useContext, useState } from 'react'

interface BottomNavigationVisibilityContextType {
  isVisible: boolean
  setIsVisible: Dispatch<SetStateAction<boolean>>
}

const BottomNavigationVisibilityContext = createContext<BottomNavigationVisibilityContextType | null>(null)

export const BottomNavigationVisibilityProvider = ({
  children,
  initialValue = true,
}: {
  children: ReactNode
  initialValue?: boolean
}) => {
  const [isVisible, setIsVisible] = useState<boolean>(initialValue)

  return (
    <BottomNavigationVisibilityContext.Provider value={{ isVisible, setIsVisible }}>
      {children}
    </BottomNavigationVisibilityContext.Provider>
  )
}

export const useBottomNavigationVisibility = () => {
  const context = useContext(BottomNavigationVisibilityContext)
  if (context === null) {
    throw new Error('useBottomNavigationVisibility must be used within BottomNavigationVisibilityProvider')
  }
  return context
}
